import { getFilteredSuggest } from './getFilteredSuggest';
import { EGender, EPartsLower, TGetFIOSuggest, TSetSuggestFiltered, TSetSuggestPart } from '../../../types/fio';

export interface IUsesetSuggestParams {
  inputSplitValue: string[];
  gender: EGender;
  currentPartFIO: EPartsLower;
  queryIndex: number;
  setSuggestFiltered: TSetSuggestFiltered;
  setSuggestPart: TSetSuggestPart;
  getFIOSuggest: TGetFIOSuggest;
}

export async function setSuggest({
  inputSplitValue,
  gender,
  currentPartFIO,
  queryIndex,
  setSuggestFiltered,
  setSuggestPart,
  getFIOSuggest,
}: IUsesetSuggestParams) {
  const response = await getFIOSuggest(inputSplitValue[queryIndex], currentPartFIO, gender);

  if (response.suggestions.length) {
    const filteredSuggest = getFilteredSuggest(response.suggestions, gender, currentPartFIO);
    const fioData = filteredSuggest.find(
      item => item.value.toLowerCase().indexOf(inputSplitValue[queryIndex].toLowerCase()) === 0,
    );

    setSuggestFiltered(filteredSuggest);

    if (fioData) {
      /**
       * Если есть саджест и в инпут что-то ввели, добавляем добивку из саджеста к тому что ввели
       * Н-р:
       * Ввели "Алек", добавляем в конец "сандр"
       */
      if (fioData.data[currentPartFIO as keyof typeof fioData.data]) {
        setSuggestPart(
          // oxlint-disable-next-line typescript/no-non-null-assertion
          fioData.data[currentPartFIO as keyof typeof fioData.data]!.substring(inputSplitValue[queryIndex].length),
        );
      }
    }
  }
}
